import * as React from "react"

const LanguageIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 170.08 140.42"
    {...props}
  >
    <g data-name="Layer 2">
      <rect
        width={500}
        height={100}
        rx={10}
        style={{
          fill: "#b499c7",
        }}
      />
      <path d="M9.84 22.86v-6.28h74.09v6.28H54.06v17.69a16.43 16.43 0 0 1 4.63-2.12 26.72 26.72 0 0 1 2.94-.64 20 20 0 0 1 3-.22 13.16 13.16 0 0 1 7.55 2.13 14.74 14.74 0 0 1 5 6.21 17.47 17.47 0 0 1 1.72 7 14.35 14.35 0 0 1-3.71 9.49 16.11 16.11 0 0 1-8.7 6.18l-3.06-5.91 2.87-1.33c.68-.3 1.35-.64 2-1s1.41-.81 2.24-1.33q5-3.44 5-8.25a6.54 6.54 0 0 0-1-3.58A5.41 5.41 0 0 0 71 44.3c-.8-.12-1.76-.22-2.89-.32s-2.28-.13-3.45-.13a5.06 5.06 0 0 0-2.11.52 10.92 10.92 0 0 0-2.34 1.54A22.57 22.57 0 0 0 56 50a19.62 19.62 0 0 0-1.9 2.34v30l-7.72-7.24V61.3a16.46 16.46 0 0 1-5.58 3.62 19.09 19.09 0 0 1-7.8 1.74 14.27 14.27 0 0 1-5.9-1.23A17.69 17.69 0 0 1 22 62a17 17 0 0 1-3.54-4.81 12.68 12.68 0 0 1-1.25-5.62A16.13 16.13 0 0 1 20.8 41.2a14.89 14.89 0 0 1 9.2-5.6l3-.28a14.78 14.78 0 0 1 13.3 7.29v2.84a14 14 0 0 0-9.3-3.53 13.75 13.75 0 0 0-9.58 3.62q-5 4.68-5 9.85a6.66 6.66 0 0 0 1.48 4.49 6 6 0 0 0 4.58 2q3.8 0 10.61-4.4a18.63 18.63 0 0 0 4.77-5 17.79 17.79 0 0 0 2.55-5.51V22.86Z" />
      <rect
        x={68.08}
        y={38.42}
        width={100}
        height={100}
        rx={10}
        style={{
          fill: "#fcfcfc",
          stroke: "#432c5b",
          strokeMiterlimit: 10,
          strokeWidth: 4,
        }}
      />
      <path d="m108.06 97.26-6.37 19.08H93.5l20.83-60.66h9.55l20.93 60.66h-8.46l-6.55-19.08Zm20.1-6.12-6-17.46c-1.37-4-2.28-7.56-3.19-11.07h-.18c-.91 3.6-1.91 7.29-3.09 11l-6 17.55Z" />
    </g>
  </svg>
)

export default LanguageIcon;
